
import React from 'react'
import { Text } from 'react-native'

export default function LineBreak() {
  let lineBreaks = '\n'
  return (<Text>{lineBreaks}</Text>)
}
